import { usePremium } from "context/PremiumContext";
import LinkCard from "./components/LinkCard";
import ProfileDetails from "./components/ProfileDetails";
import RightSection from "./components/RightSection";
import "./style.scss";
import { useProfileCompletion } from "hooks/api/useHome";
import { useEffect } from "react";
import { storeToken } from "utils/storage";

function HomePage() {
  const { data: userData, isLoading } = useProfileCompletion();
  const { setIsPremium } = usePremium();

  useEffect(() => {
    if (userData?.common_home_data?.is_premium_member !== undefined) {
      setIsPremium(userData.common_home_data.is_premium_member);
    }
    if (userData?.common_home_data?.onboarding_steps !== undefined) {
      storeToken(
        "onboarding_steps",
        userData?.common_home_data?.onboarding_steps,
      );
    }
  }, [userData, setIsPremium]);

  return (
    <div className="container flex items-start gap-10 home-page ">
      <div className="left-section">
        <ProfileDetails
          profileData={userData?.common_home_data}
          isLoading={isLoading}
        />
        <LinkCard />
      </div>
      <RightSection
        profileData={userData?.common_home_data}
        isLoading={isLoading}
      />
    </div>
  );
}

export default HomePage;
